export default __webpack_public_path__ + "static/aikido-bostjan-b7efeb4126b052e83ada0cee6a2c303e.jpg";